export const DIPLOMATEN_CODE = 'AA-World';
export const AKTION_10 = 'Aktion10';
export const TIER_10 = 'Tier10';
